import { Badge, Flex } from "antd";
import classNames from "classnames";
import isToday from "dayjs/plugin/isToday";
import weekday from "dayjs/plugin/weekday";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isWeekend, useCalendarEvents } from "@/features/calendar/model";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import styles from "./styles.module.scss";

type CalendarEventMobileProps = {
  date: Dayjs;
};

dayjs.extend(weekday);
dayjs.extend(isToday);

export const DateValueRender: FC<CalendarEventMobileProps> = ({ date }) => {
  const { i18n } = useTranslation();
  const { hasEvents, isFetching } = useCalendarEvents(date);

  return (
    <Flex justify="end" key={date.date()}>
      {date.isToday() && hasEvents && (
        <div className={styles["has-events"]}>
          <Badge color="gold" />
        </div>
      )}
      <span
        className={classNames(styles.content, {
          [styles["content__today"]]: date.isToday() && !isWeekend(i18n.language, date),
          [styles["content__weekend--today"]]: date.isToday() && isWeekend(i18n.language, date),
          [styles["content__loading"]]: isFetching,
        })}
      >
        {date.date().toString().padStart(2, "0")}
      </span>
    </Flex>
  );
};
